import { render, staticRenderFns } from "./commissioniPolizzeDistributori.vue?vue&type=template&id=4284f448&"
import script from "./commissioniPolizzeDistributori.vue.ts?vue&type=script&lang=ts&"
export * from "./commissioniPolizzeDistributori.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports